/**
 * Constants
 */
const DEV = "DEV";
const PRODUCTION = "PRODUCTION";
const TESTING = "TESTING";

const devBaseURL = "https://store-api.oscart.click";
const productionBaseURL = "https://store-api.onesitecart.com";
const testingBaseURL = "https://store-api.oscart.click";

const devBasePath = "/store";
const productionBasePath = "/store";
const testingBasePath = "/store";

const devApiTimeOverAllowance = 50 * 1000; // 50 seconds timeout
const productionApiTimeOverAllowance = 50 * 1000;
const testingApiTimeOverAllowance = 50 * 1000;

// Change this value to test different environment
export const ENVIRONMENT = DEV;

export const getBuildConfig = () => {
  switch (ENVIRONMENT) {
    case DEV:
      return {
        baseUrl: devBaseURL,
        basePath: devBasePath,
        apiTimeOverAllowance: devApiTimeOverAllowance,
      };
    case PRODUCTION:
      return {
        baseUrl: productionBaseURL,
        basePath: productionBasePath,
        apiTimeOverAllowance: productionApiTimeOverAllowance,
      };
    case TESTING:
      return {
        baseUrl: testingBaseURL,
        basePath: testingBasePath,
        apiTimeOverAllowance: testingApiTimeOverAllowance,
      };
    default:
      throw new Error("Unsupported Environment");
  }
};
